import { render, staticRenderFns } from "./real_name.vue?vue&type=template&id=566b8e9b&scoped=true"
import script from "./real_name.vue?vue&type=script&lang=js"
export * from "./real_name.vue?vue&type=script&lang=js"
import style0 from "./real_name.vue?vue&type=style&index=0&id=566b8e9b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566b8e9b",
  null
  
)

export default component.exports